import { RuleObject } from 'antd/es/form';

export const validateForm = (_: RuleObject, value: string, field: string, min: number, max: number): Promise<void> => {
  return value?.trim()?.replace(/\s+/g, '').length < min || value?.trim()?.replace(/\s+/g, '').length > max
    ? Promise.reject(new Error(`${field} must be between ${min} - ${max} characters`))
    : Promise.resolve();
};

export const normalize = (value: string): string => value?.trimStart()?.replace(/\s+/g, ' ');
